import { render, staticRenderFns } from "./cl-tabs.vue?vue&type=template&id=9428c058&scoped=true&"
import script from "./cl-tabs.vue?vue&type=script&lang=ts&"
export * from "./cl-tabs.vue?vue&type=script&lang=ts&"
import style0 from "./cl-tabs.vue?vue&type=style&index=0&id=9428c058&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9428c058",
  null
  
)

export default component.exports